module App.Classes {
    export class User  {
        gender: string;
        firstName: string;
        middleName: string;
        lastName: string;
        email: string;
        phoneNumber: string;
        address: string;
        zipcode: string;
        city: string;
        licensePlates: LicensePlate[];
        landingPageUrl: string;
    }

    export class LicensePlate {
        licensePlate: string;
        apkWarning: boolean;
        maintenanceWarning: boolean;
        tireWarning: boolean;
    }
}